import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import { LinkAuthenticationElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Config } from 'src/config';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';

export default function CheckoutForm({ amount, currencySymbol,planName }) {
  const { t: translate } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToaster();

  const getUserEmail = () => {
    let email = '';
    let userDetails = CommonHelper.GetLoggedInUserDetailsFromLocalStorage();
    if (userDetails) email = userDetails.email;
    return email;
  };
  const userEmail = getUserEmail();
useEffect(() => {
    if (planName && amount) {
      localStorage.setItem('planName', planName);
      localStorage.setItem('planValue', amount.toString());
      localStorage.setItem('currency', currencySymbol === "₹" ? "INR" : "USD")
    }
  }, [planName, amount]);
  useEffect(() => {
    var emailElement = document.getElementById('Field-emailInput');
    if (emailElement) emailElement.disabled = true;
  }, []);

  useEffect(() => {
    if (!stripe) {
      return;
    }
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          showToast(`${translate('billing.subscription_info.payment_success')}!`, 'e');
          break;
        case 'processing':
          showToast(translate('billing.subscription_info.payment_processing'), 'e');
          break;
        case 'requires_payment_method':
          showToast(translate('billing.subscription_info.payment_not_success'), 'e');
          break;
        default:
          showToast(translate('common.something_went_wrong'), 'e');
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: Config.Stripe.redirectUri,
      },
    });
    showToast(error.message ? error.message : translate('common.something_went_wrong'), 'e');

    setIsLoading(false);
  };

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <LinkAuthenticationElement
          id="link-authentication-element"
          options={{
            defaultValues: {
              email: userEmail,
            },
          }}
        />
        <PaymentElement id="payment-element" />
        <Stack direction="row" alignItems="center" sx={{ mt: 3, mb: 1, float: 'left' }}>
          <Typography sx={{ fontWeight: 800 }}>
            {translate('common.total')} = {currencySymbol}
            {amount}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" sx={{ mt: 2, mb: 1, float: 'right' }}>
          <LoadingButton
            disabled={isLoading || !stripe || !elements}
            id="submit"
            type="submit"
            loading={isLoading}
            color="primary"
            variant="outlined"
          >
            {translate('billing.subscription_info.pay_now')}
            Pay Now
          </LoadingButton>
        </Stack>
      </form>
    </>
  );
}
